var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Icon',{class:("block-type-icon block-type-icon--" + _vm.type),attrs:{"icon":("block-" + _vm.type)}})}
var staticRenderFns = []

export { render, staticRenderFns }